export const AIDetectionStatus = {
  NATURALLY_DELIVERY: "Natural Delivery",
  POSSIBLY_SCRIPTED: "Possibly Scripted",
  AI_GENERATED_RISK: "AI-generated Risk",
  NOT_ANALYZED: "Not Analyzed"
} as const;


export const AIDetectionStatusConfig = {
  [AIDetectionStatus.NATURALLY_DELIVERY]: {
    backgroundColor: "tertiary-green-10",
    textColor: "tertiary-green",
    iconColor: "#0FAC00"
  },
  [AIDetectionStatus.POSSIBLY_SCRIPTED]: {
    backgroundColor: "tertiary-orange-10",
    textColor: "tertiary-orange",
    iconColor: "#F47704"
  },
  [AIDetectionStatus.AI_GENERATED_RISK]: {
    backgroundColor: "tertiary-red-10",
    textColor: "tertiary-red",
    iconColor: "#E11F1F"
  },
  [AIDetectionStatus.NOT_ANALYZED]: {
    backgroundColor: "tertiary-grey-10",
    textColor: "black-90",
    iconColor: "#101933"
  }
};
